import logo from '../assets/images/logo_small.png';

/** Peek wordmark: brand glyph + name. */
export default function Logo({ className = '' }) {
  return (
    <span className={`logo ${className}`.trim()}>
      <img className="logo__mark" src={logo} alt="" width="32" height="32" />
      <span className="logo__name">Peek</span>
    </span>
  );
}
